// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__2Act5"};